export default __webpack_public_path__ + "static/covid19-905e4a5455295bd00251f9be33be8320.gif";